<i18n lang="yaml">
ru:
  page_title: 'Заказ по списку номеров'
  order_by_oem: 'Заказ по списку номеров'
  upload_button: 'Загрузить'
  invalid_data: 'Данные содержат ошибки.'
  express_cart_warning: 'Т.к. создана экспресс-корзина, товары можно добавить только в экспресс-заказ.'
en:
  page_title: 'Order by products codes'
  order_by_oem: 'Order by products codes'
  upload_button: 'Upload'
  invalid_data: 'Entered data is invalid.'
  express_cart_warning: 'Only express order is available because express cart exists.'
</i18n>

<template>
  <div class="container">
    <breadcrumbs :breadcrumbs="breadcrumbs" />
    <h1>{{ $t('order_by_oem') }}</h1>
    <!-- <div class="checkbox mb-5" v-if="showExpressCheckbox">
      <label @click="notifyExpressCart" :class="{'checked': searchHistory.express}">
      <input v-model="searchHistory.express" :disabled="disabledExpressCheckbox" class="styled-checkbox" type="checkbox">
      {{ $t('express') }}</label>
    </div> -->
    <div class="search-oem">
      <div class="field" :class="{'error': errors.query && errors.query.length}">
        <label class="error-label" v-if="errors.query && errors.query.length && !searchHistory.query">{{ errors.query[0] }}</label>
        <textarea ref="textareaOem" v-model="searchHistory.query" @focusin="focusTextarea" @blur="showTip = true"
                  spellcheck="false" placeholder=" " :style="{'min-height': `${textAreaHeight}px`}"></textarea>
        <label v-if="errors.query && errors.query.length && searchHistory.query">{{ errors.query[0] }}</label>
        <label v-else></label>
        <site-text-block ref="oem_search_text" v-show="showTextAreaInfoBlock" type="oem_search" class="tip"
                         @click.native="focusTextarea()"/>
        <button :class="{'disabled': !searchHistory.query}" @click="submitSearch">{{ $t('upload_button') }}</button>
      </div>
      <div class="field-tip">
        <site-text-block v-show="!showTextAreaInfoBlock" type="oem_search" class="tip-left"/>
      </div>
    </div>
  </div>
</template>

<script>
import {rememberExpiresMixin} from '@/mixins';
import {SearchHistory} from '@/models/search-history';

import Breadcrumbs from '@/components/breadcrumbs';
import Modal from '@/components/modal';
import SiteTextBlock from '@/components/blocks/site-text-block';

export default {
  components: {
    Breadcrumbs,
    Modal,
    SiteTextBlock,
  },
  mixins: [rememberExpiresMixin],
  data() {
    return {
      breadcrumbs: [{name: this.$t('search_by_number')}],
      showTip: true,
      searchHistory: new SearchHistory({}),
      errors: {},
      textAreaHeight: 0,
    }
  },
  computed: {
    addToCartMode() {
      return this.searchHistory.query && this.searchHistory.query.search('\t') > -1;
    },
    showTextAreaInfoBlock() {
      return this.showTip && !this.searchHistory.query;
    },
    disabledExpressCheckbox() {
      return this.$store.getters.cartExists.count > 0;
    },
    showExpressCheckbox() {
      return this.$auth.loggedIn && this.$auth.hasScope('is_extra') && (
        !this.$store.getters.cartExists.count || this.$store.getters.cartExists.express);
    },
  },
  created() {
    this.$store.dispatch('setCartExists', () => {
      if (this.$store.getters.cartExists.count) {
        this.searchHistory.express = this.$store.getters.cartExists.express;
      }
    });
  },
  mounted() {
    if (this.$device.isMobile) {
      this.$router.push({
        path: this.localePath('/'),
      })
    }
    const intervalId = setInterval(() => {
      if (this.$refs.oem_search_text && this.$refs.oem_search_text.$el && this.$refs.oem_search_text.$el.clientHeight
      && this.$refs.oem_search_text.$el.children.length > 0) {
        this.textAreaHeight = this.$refs.oem_search_text.$el.children[0].clientHeight + 110;
        clearInterval(intervalId);
      }
    }, 50);
  },
  head() {
    return {
      title: this.$t('page_title'),
    }
  },
  methods: {
    focusTextarea() {
      this.errors.query = null;
      this.showTip = false;
      this.$refs.textareaOem.focus();
    },
    redirectToCart() {
      this.$router.push({path: this.localePath('/cart/')});
    },
    async submitSearch() {
      try {
        this.searchHistory = await this.searchHistory.config({count_loading: this.addToCartMode}).save();
        await this.$store.dispatch('setCartExists');
        await this.$store.dispatch('setPriceRequestExists');
        await this.$router.push({
          path: this.localePath(`/search/oem/${this.searchHistory.id}/`),
          query: {'new': null},
        });
      } catch (e) {
        if (this.addToCartMode) {
          this.$notify({
            duration: -1,
            text: e.response.data.query[0],
          });
          this.errors = {
            query: [this.$t('invalid_data')],
          };
        } else {
          this.errors = e.response.data;
        }
        this.searchHistory = new SearchHistory({query: this.searchHistory.query});
      }
    },
    notifyExpressCart() {
      if (this.disabledExpressCheckbox) {
        this.$notify({
          duration: 5000,
          text: this.$t('express_cart_warning'),
        });
      }
    },
  }
}
</script>
